import { IFormSection } from "../../../model/form/FormSection";
import FormSectionQualifierPresentationModel, {
  IFormSectionQualifierPresentationModel
} from "./FormSectionQualifierPresentationModel";
import { IFormSectionQualifier } from "../../../model/form/FormSectionQualifier";

export interface TFormSectionPresentationModel {
  comment: string;
  id: number;
  label: string;
  labelVisible: boolean;
  level: number;
  maxNumber: number;
  orderNumber: number;
  orderNumberVisible: boolean;
  formSectionId: number;
  required: boolean;
  isRequiredFlagVisible: boolean;
  segmentRowsChanged: number[];
  qualifiers?: IFormSectionQualifierPresentationModel[];
  subsections: IFormSectionPresentationModel[];
  formTypeCode: string;
  portalAggregate: boolean;
}
export interface IFormSectionPresentationModel
  extends TFormSectionPresentationModel {
  qualifiers?: IFormSectionQualifierPresentationModel[];
  subsections: IFormSectionPresentationModel[];
}
const isQualifierChanged = (qualifier: IFormSectionQualifier) => {
  let valueExists: number[] = [];

  qualifier.attributes?.forEach((attribute) => {
    attribute.values.forEach((value) => {
      if (value.value !== null && value.value !== undefined) {
        valueExists.push(value.recordOrderNumber);
      }
    });
  });
  return valueExists;
};

const getAllRows = (formSection: IFormSection) => {
  let rowOrderNumbers: number[] = [];
  if (
    formSection.qualifiers !== undefined &&
    formSection.qualifiers.length > 0
  ) {
    formSection.qualifiers[0].attributes?.forEach((attribute) => {
      attribute.values.forEach((item) => {
        rowOrderNumbers.push(item.recordOrderNumber);
      });
    });
  }

  if (rowOrderNumbers.length === 0 && formSection.maxNumber === -1) {
    rowOrderNumbers.push(1);
  }
  return rowOrderNumbers;
};
const getChangedSegmentRows = (data: IFormSection) => {
  let segmentRowsChanged: number[] = [];
  if (data.required) {
    Array.prototype.push.apply(segmentRowsChanged, getAllRows(data));
  } else {
    data.qualifiers?.forEach((item) => {
      Array.prototype.push.apply(segmentRowsChanged, isQualifierChanged(item));
    });
  }
  segmentRowsChanged = Array.from(new Set(segmentRowsChanged));
  return segmentRowsChanged;
};
const FormSectionPresentationModel = (
  data: IFormSection
): IFormSectionPresentationModel => {
  let _segmentRowsChanged = getChangedSegmentRows(data);
  let _isRequiredFlagVisible = data.required;
  return {
    comment: data.comment,
    id: data.id,
    label: data.label,
    labelVisible: data.labelVisible,
    level: data.level,
    maxNumber: data.maxNumber,
    orderNumber: data.orderNumber,
    orderNumberVisible: data.orderNumberVisible,
    formSectionId: data.formSectionId,
    required: data.required,
    segmentRowsChanged: _segmentRowsChanged,
    isRequiredFlagVisible: _isRequiredFlagVisible,
    qualifiers: data.qualifiers.map((qualifier) => {
      return FormSectionQualifierPresentationModel(
        qualifier,
        _segmentRowsChanged
      );
    }),
    subsections: data.subsections.map((section) => {
      return FormSectionPresentationModel(section);
    }),

    formTypeCode: data.formTypeCode,
    portalAggregate: data.portalAggregate
  };
};

export default FormSectionPresentationModel;
